export default "__VITE_ASSET__$JuVvYqB__"